import React, { ReactElement } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { updatePickTour } from '../../../../redux/actions/activePickTour.actions';

import { selectIsSmartSourcingEnabled, getActivePickTourState, isEditOrderEnabled } from '../../../../redux/selectors';

import {
  PICK_TOUR_STATUS_CLOSED,
  PICK_TOUR_SUB_STATUS_PARTFILL,
  PICK_TOUR_SUB_STATUS_SKIPPED,
  ORDER_TYPE_COMMERCIAL_EP,
  SKIP_ITEMS_ACTION_EDIT_ORDER,
  SKIP_ITEMS_ACTION_FINALIZE,
  SKIP_ITEMS_ACTION_NONE,
} from '../../../../constants';
import { SkipItemsAction } from '../../../../redux/sagas/types';

import CommercialSkippedItemReportView from './CommercialSkippedItemReportView';
import EPSkippedItemReportView from './EPSkippedItemReportView';

const CommercialSkipFlow = (): ReactElement => {
  const { t } = useTranslation();
  const translationRoot = 'COMMERCIAL_SKIP_FLOW';
  const activePickTourState = useSelector(getActivePickTourState);
  const dispatch = useDispatch();

  const isSmartSourcingEnabled = useSelector(selectIsSmartSourcingEnabled);
  const editOrderEnabled = useSelector(isEditOrderEnabled);

  if (!activePickTourState) {
    return <span>{t(`${translationRoot}.BUTTONS.MISSING_DATA`)}</span>;
  }

  const { forwardingStore, pickTour } = activePickTourState;
  const { picks } = pickTour;
  const isEpHub = picks[0]?.orderType === ORDER_TYPE_COMMERCIAL_EP;

  const handleUpdatePickTour = (action: SkipItemsAction) => {
    dispatch(
      updatePickTour({
        updateType: 'finish',
        updateStatus: {
          pickTourStatus: PICK_TOUR_STATUS_CLOSED,
          pickTourSubStatus: picks.some(pick => pick.pickedQuantity !== 0)
            ? PICK_TOUR_SUB_STATUS_PARTFILL
            : PICK_TOUR_SUB_STATUS_SKIPPED,
        },
        skipItemsAction: action,
      })
    );
  };

  if (isEpHub) {
    return <EPSkippedItemReportView picks={picks} onComplete={() => handleUpdatePickTour(SKIP_ITEMS_ACTION_NONE)} />;
  }

  return (
    <CommercialSkippedItemReportView
      picks={picks}
      forwardingStore={forwardingStore}
      editOrderEnabled={editOrderEnabled}
      isSmartSourcingEnabled={isSmartSourcingEnabled}
      onComplete={() => handleUpdatePickTour(editOrderEnabled ? SKIP_ITEMS_ACTION_FINALIZE : SKIP_ITEMS_ACTION_NONE)}
      onEdit={() => handleUpdatePickTour(SKIP_ITEMS_ACTION_EDIT_ORDER)}
    />
  );
};

export default CommercialSkipFlow;
